import CustomDrawer from 'components/commom/CustomDrawer';
import { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { CircularProgress, IconButton } from '@mui/material';
import LabelWithInput from 'components/commom/LabelWithPracticeInput';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import 'assets/styles/common.scss';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import SelectInput from 'components/commom/SelectInput';
import { useDispatch, useSelector } from 'react-redux';
import { createStaffCallAPI } from 'store/Enterprise/staff/createStaff/action';
import { useNavigate } from 'react-router-dom';
import CommonToast from 'components/commom/CommonToast';
import { ClearTokenRedirectLogin, getUserRole } from 'utils/general';

const CreateStaff = ({ open, onClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const userRole = getUserRole();
  const [formValue, setFormValue] = useState({
    name: '',
    email: '',
    dob: '',
    gender: null,
    password: '',
    location: '',
  });
  const [formId, setFormId] = useState({
    location: '',
  });
  const [phoneNumber, setPhoneNumber] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [isPassVisible, setIsPassVisible] = useState(false);

  const genderData = useSelector(
    (state) => state?.getMasterDataReducer?.users?.data
  );
  const locationData = useSelector(
    (state) => state?.getLocationReducer?.users?.data
  );
  const particularEnterprise = useSelector(
    (state) => state?.basicDetailsValueReducer?.particularEnterprise
  );
  const createStaffLoader = useSelector(
    (state) => state?.createStaffReducer?.loading
  );
  const enterpriseData = useSelector(
    (state) => state?.getEnterpriseProfileReducer?.users?.data
  );

  useEffect(() => {
    if (open) {
      initialState();
    }
  }, [open]);

  const initialState = () => {
    setFormValue({
      name: '',
      email: '',
      dob: '',
      gender: genderData?.[0]?.values?.[0] || null,
      password: '',
      location: '',
    });
    setFormId({
      location: '',
    });
    setPhoneNumber('');
    setCountryCode('');
    setIsPassVisible(false);
  };

  const handleBack = () => {
    onClose();
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleData = (data, type) => {
    setFormValue((prev) => ({
      ...prev,
      [type]: data,
    }));
  };

  const handlePhoneChange = (value, country) => {
    const countryCode = `+${country?.dialCode}`;
    const contactNumber = value.replace(country?.dialCode, '').trim();

    setPhoneNumber(contactNumber);
    setCountryCode(countryCode);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue((prev) => ({
      ...prev,
      [name]: value?.name,
    }));
    setFormId((prev) => ({
      ...prev,
      [name]: value?.id,
    }));
  };

  const handleSave = () => {
    const body = {
      id:
        userRole === 'enterprise-admin'
          ? enterpriseData?.enterprise?.enterprise_id
          : particularEnterprise?.id,
      detail: {
        name: formValue?.name,
        contact_number: phoneNumber,
        country_code: countryCode,
        email: formValue?.email,
        date_of_birth: formValue?.dob,
        gender_id: formValue?.gender?.id,
        location_id: formId?.location,
        password: formValue?.password,
      },
    };

    dispatch(
      createStaffCallAPI(body, {
        run: true,
        handleFunction: (res) => {
          showToast(res?.message, 'success');
          handleBack();
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      })
    );
  };

  return (
    <CustomDrawer
      open={open}
      onClose={() => {
        handleBack();
      }}
      width={{ xs: '100vw', md: '70vw', xl: '40vw' }}
    >
      <div className="relative h-full min-h-[400px] flex flex-col">
        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto p-[25px] pb-[15%]">
          <div className="mt-[43px]">
            <div className="flex items-center justify-between gap-[20px]">
              <p className="p-0 m-0 text-[24px] text-[#292D32] family_outfit_semiBold_600 lh-176">
                Invite Enterprise Staff
              </p>
              <IconButton onClick={handleBack}>
                <CloseIcon />
              </IconButton>
            </div>
            <div className="mt-[24px]">
              <LabelWithInput
                label="Name"
                placeholder="Name"
                name="name"
                type="text"
                value={formValue?.name}
                onChange={(e) => handleInputChange(e)}
                // errorText={
                //   isError &&
                //   isError?.question_text?.error &&
                //   isError?.question_text?.errorMessage
                // }
              />
            </div>
            <div className="mt-[16px]">
              <div className="text-[14px] lh-201 family_outfit_medium_500 fc-292D32 mb-[4px]">
                Mobile number
              </div>
              <PhoneInput
                id="phone-input"
                country={'in'}
                inputProps={{
                  name: 'phoneNumber',
                  required: true,
                }}
                name={'phoneNumber'}
                value={`${countryCode}${phoneNumber}`}
                onChange={(value, country) => handlePhoneChange(value, country)}
                placeholder="Enter phone number"
                inputClass="custom-input-register"
                containerClass="custom-container-register"
              />
            </div>
            <div className="mt-[16px]">
              <LabelWithInput
                label="Email ID"
                placeholder="Email ID"
                name="email"
                type="text"
                value={formValue?.email}
                onChange={(e) => handleInputChange(e)}
              />
            </div>
            <div className="mt-[16px]">
              <LabelWithInput
                label="Date of Birth"
                placeholder="Date of Birth"
                name="dob"
                type="date"
                value={formValue?.dob}
                onChange={(e) => handleInputChange(e)}
              />
            </div>
            <div className="mt-[16px]">
              <SelectInput
                label="Location"
                placeholder={'Location'}
                colorIcon={'#292D32'}
                name={'location'}
                value={formValue?.location}
                data={locationData || []}
                onChange={handleChange}
                // errorText={
                //   isError &&
                //   isError?.questionType?.error &&
                //   isError?.questionType?.errorMessage
                // }
              />
            </div>
            <div className="mt-[16px]">
              <div className="text-[14px] lh-201 family_outfit_medium_500 fc-292D32">
                Gender
              </div>
              <div className="mt-[4px] grid grid-cols-2 gap-[10px]">
                {genderData?.[0]?.values?.map((data, index) => (
                  <div
                    key={index}
                    className={`text-[14px] family_outfit_regular_400 lh-16 h-[45px] cursor-pointer flex items-center justify-center border-1 border-[#998A7B] ${formValue?.gender?.slug === data?.slug ? 'bg-[#874529] text-white' : 'text-[#874529]'}`}
                    onClick={() => {
                      handleData(data, 'gender');
                    }}
                  >
                    <div>{data?.name}</div>
                  </div>
                ))}
              </div>
            </div>
            <div className="mt-[16px]">
              <LabelWithInput
                label="Password"
                placeholder="Password"
                name="password"
                value={formValue?.password}
                type={isPassVisible ? 'text' : 'password'}
                onChange={handleInputChange}
                InputProps={{
                  endAdornment: (
                    <>
                      {isPassVisible ? (
                        <VisibilityOutlinedIcon
                          sx={{ cursor: 'pointer', color: '#A4AAB2' }}
                          onClick={() => setIsPassVisible(!isPassVisible)}
                        />
                      ) : (
                        <VisibilityOffOutlinedIcon
                          sx={{ cursor: 'pointer', color: '#A4AAB2' }}
                          onClick={() => setIsPassVisible(!isPassVisible)}
                        />
                      )}
                    </>
                  ),
                }}
                // errorText={
                //   isError &&
                //   isError.password.error &&
                //   isError.password.errorMessage
                // }
              />
            </div>
          </div>
        </div>
        <div
          className="mt-[30px] absolute left-0 bottom-0 w-full bg-[#375241] p-[30px] cursor-pointer"
          onClick={() => {
            !createStaffLoader && handleSave();
          }}
        >
          <div className="text-[24px] text-white family_outfit_semiBold_600 lh-176 text-center flex items-center justify-center gap-[10px]">
            {'Save'}
            {createStaffLoader ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              <span
                style={{ width: 24, height: 24, display: 'inline-block' }}
              />
            )}
          </div>
        </div>
      </div>
    </CustomDrawer>
  );
};

export default CreateStaff;
